import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';
import ViewAllAccountsListItemPicker
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/BalanceSheet/StepLayout/BalanceSheetContent/BalanceSheetTabContent/BalanceSheetLineItemSection/Body/LineItem/ManageLineItemModal/ContentPicker/AccountContent/Body/ViewAllAccountsListItemPicker';

const styles = () => ({
  root: {},
  actionList: {},
  actionListItem: {},
});

const Body = ({
  className,
  classes,
  lineItemResource,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <List1
        className={classes.actionList}
      >
        <ViewAllAccountsListItemPicker
          className={classes.actionListItem}
          lineItemResource={lineItemResource}
        />
      </List1>
    </Box>
  );
};

Body.defaultProps = {
  className: '',
};

Body.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  lineItemResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Body);
